import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';
import PaperSection from '@rossum/components/paper-section/PaperSection';
import { Stack, Typography } from '@rossum/ui/material';
import ControlledToggle from '../../../../../components/ReactHookForm/Toggle';
import { UnpaidFeatureOverlay } from '../../../../../features/pricing/components/UnpaidFeatureOverlay';
import { queueSettingsRowSx } from '../../../queueSettingsRowSx';
import { QueueSettingsData } from './formType';
import QueueSettingsLabel from './QueueSettingsLabel';

type DocumentArchiveProps = {
  control: Control<QueueSettingsData>;
  disabled: boolean;
};

const DocumentArchive = ({ disabled, control }: DocumentArchiveProps) => {
  const intl = useIntl();

  return (
    <PaperSection
      title={intl.formatMessage({
        id: 'containers.settings.queues.titles.documentArchive',
      })}
      sx={{ position: 'relative' }}
    >
      <Stack direction="row" sx={queueSettingsRowSx}>
        <div>
          <QueueSettingsLabel titleId="containers.settings.queues.documentArchive.label" />
        </div>
        <Stack direction="row">
          <ControlledToggle<QueueSettingsData>
            control={control}
            name="archiveEnabled"
            disabled={disabled}
          />
        </Stack>
      </Stack>

      <Stack pt={1} width={600}>
        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage({
            id: 'containers.settings.queues.documentArchive.description',
          })}
        </Typography>
      </Stack>
      {disabled && (
        <Stack
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <UnpaidFeatureOverlay
            title={intl.formatMessage({
              id: 'features.pricing.unpaidFeatureOverlay.title.documentArchive',
            })}
            dataCy="unpaid-overlay-queue-settings-document-archive"
          />
        </Stack>
      )}
    </PaperSection>
  );
};

export default DocumentArchive;
